<template>
  <div class="page-container">
    <div class="top-container">
      <el-radio-group v-model="radio">
        <el-radio border label="1">{{ $str.getKey('策略控制/工作日策略') }}</el-radio>
        <el-radio border label="2">{{ $str.getKey('策略控制/休息日策略') }}</el-radio>
      </el-radio-group>

      <div class="operate-btns-container">
        <el-button plain class="edit" @click="startEdit" v-if="!hideEditButton">{{ $str.getKey('策略控制/编辑') }}</el-button>
        <el-button plain class="copy" @click="copyStrategy">{{ $str.getKey('策略控制/复制') }}</el-button>
        <el-button plain class="paste" @click="pasteStrategy" :disabled="!isEdit">{{ $str.getKey('策略控制/粘贴')
        }}</el-button>
        <el-button plain class="clear" @click="tableData = []" :disabled="!isEdit">{{ $str.getKey('策略控制/清空')
        }}</el-button>
      </div>
    </div>
    <div class="main-container" ref="mainContainerRef">

      <!-- 防逆流开关 -->
      <div class="anti-reflux-container">
        <div v-if="hasAntiRefluxPermission">
          <span class="anti-reflux-label">{{ $str.getKey('策略控制/防逆流') }}:</span>
          <el-switch v-model="antiRefluxEnabled" @change="onAntiRefluxChange" :disabled="!isEdit"></el-switch>
          <el-input-number v-model="antiRefluxValue" :min="-65535" :max="65535" :step="1" :disabled="!isEdit"
            @change="onAntiRefluxValueChange"></el-input-number>
          <span class="anti-reflux-value" v-if="checkPermi(['ops:strategyControl:PVstorage'])">
            {{ $str.getKey('策略控制/当前防逆流值') }}: {{ radio === '1' ? workDemandMin : restDemandMin }}
          </span>
          <span class="edit-hint" v-if="!isEdit">{{ $str.getKey('策略控制/点击编辑按钮可修改') }}</span>
        </div>
        <!-- <div v-else>
          <span class="edit-hint">防逆流需要回执函才能显示，若需要请联系奇点售后运维团队！</span>
        </div> -->
      </div>
      <!-- 表格 -->
      <div class="table-wrap">
        <el-table v-if="true" :data="tableData" ref="tableRef" :span-method="mergeCellMethod"
          row-class-name="table-row" cell-class-name="table-cell" header-cell-class-name="table-header-cell">
        <el-table-column :label="$str.getKey('策略控制/开始时间')" style="font-size: 12px;">
          <template #default="{ row }">
            <div class="cell-content">
              <div v-if="!isEdit">{{ row.start_time }}</div>
              <input v-else type="time" class="s-underline-input" v-model="row.start_time" :disabled="!isEdit">
              <div class="separator" v-if="false"></div>
              <div v-if="!isEdit">{{ row.end_time }}</div>
              <input v-else type="time" class="s-underline-input" v-model="row.end_time" :disabled="!isEdit">
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$str.getKey('策略控制/结束时间')" style="font-size: 12px;">
          <template #default="{ row }">
            <div class="cell-content">
              <input type="time" class="s-underline-input" v-model="row.end_time" :disabled="!isEdit">
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="`${$str.getKey('策略控制/功率')}(${-parseInt(currentELinkData?.powerLimit)}~${parseInt(currentELinkData?.powerLimit)})`"
          style="font-size: 12px;">
          <template #default="{ row }">
            <div class="cell-content">
              <input type="number" class="s-underline-input" :class="{'input-error-value': checkValueIsInvalid(row.power, currentELinkData)}" v-model="row.power" :disabled="!isEdit"
                @change="inputPowerChange" :min="-parseInt(currentELinkData?.powerLimit)"
                :max="parseInt(currentELinkData?.powerLimit)">
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$str.getKey('策略控制/充电上限')" style="font-size: 12px;">
          <template #default="{ row }">
            <div class="cell-content">
              <input type="number" class="s-underline-input" v-model="row.upper_limit" :disabled="!isEdit" :min="0"
                :max="100" @change="onUpperLimitChange(row)">
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$str.getKey('策略控制/放电下限')" style="font-size: 12px;">
          <template #default="{ row }">
            <div class="cell-content">
              <input type="number" class="s-underline-input" v-model="row.lower_limit" :disabled="!isEdit" :min="0"
                :max="100" @change="onLowerLimitChange(row)">
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="hasPvAccess" :label="$str.getKey('策略控制/模式')" width="320" style="font-size: 12px;">
          <template #default="{ row }">
            <div class="cell-content mode-cell">
              <el-select v-model="row.running_mode" :disabled="!isEdit" :placeholder="$str.getKey('策略控制/请选择')"
                class="mode-select" size="default" @change="onModeChange(row)">
                <el-option v-for="opt in STRATEGY_MODE_OPTIONS" :key="opt.value"
                  :label="$str.getKey('策略控制/' + opt.label)" :value="opt.value"></el-option>
              </el-select>
              <input type="number" class="s-underline-input threshold-input" v-model="row.threshold_val"  v-if="checkPermi(['ops:strategyControl:PVstorage'])"
                :disabled="!isEdit || row.running_mode === '' || row.running_mode == null" min="0" max="1000" step="1" @change="onThresholdChange(row)" :placeholder="$str.getKey('策略控制/' + getThresholdPlaceholder(row.running_mode))"
                :title="$str.getKey('策略控制/' + getThresholdPlaceholder(row.running_mode))">
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$str.getKey('策略控制/操作')" width="280" fixed="right" style="font-size: 12px;">
          <template #default="{ row }">
            <div class="operate-cell-container">
              <el-button plain class="add" @click="addLine(row)" :disabled="!isEdit">
                <div class="btn-wrapper">
                  <img class="btn-icon" :src="AddPreIcon" alt="">
                  <span>{{ $str.getKey('策略控制/插入') }}</span>
                </div>
              </el-button>
              <el-button plain class="delete" @click="removeLine(row)" :disabled="!isEdit">
                <div class="btn-wrapper">
                  <img class="btn-icon" :src="DeletePreIcon" alt="">
                  <span>{{ $str.getKey('策略控制/删除') }}</span>
                </div>
                </el-button>
              <el-button plain class="move" :disabled="!isEdit" @mousedown="onSortBtnDown(row)" :class="isEdit ? 'cursor-move' : ''">
                <div class="btn-wrapper">
                  <img class="btn-icon" :src="SwitchPreIcon" alt="">
                  <span>{{ $str.getKey('策略控制/切换') }}</span>
                </div>
                </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <!-- 新增一行 -->
      <el-button @click="addToEnd" :icon="Plus" class="add-btn" plain :disabled="!isEdit">{{ $str.getKey('策略控制/新增一行')
      }}</el-button>
      <!-- 移动时的line-symbol -->
      <div class="move-bar" :style="{ top: barTop + 'px' }" v-show="visible"></div>
      <!-- 甘特图 -->
      <div class="chart-container">
        <v-chart :option="option" :autoresize="true" :width="500"></v-chart>
      </div>
    </div>

    <!-- 权限验证弹窗 -->
    <AuthVerifyDialog v-model:visible="authDialogVisible" :isAuth="hasAntiRefluxPermission" :phoneNumber="phoneNumber"
      :stationId="currentELinkData?.station_id" @cancel="onAuthCancel" @confirm="onAuthConfirm" />

    <!-- ============================ 弹框：粘贴策略 ============================ -->
    <el-dialog :title="$str.getKey('策略控制/策略文本')" v-model="pasteDialogVisible">
      <div class="tip-text">{{ $str.getKey('策略控制/请将策略文本粘贴到这里') }}</div>
      <TextEditor v-model="pastedValue" />
      <template #footer>
        <el-button @click="pasteDialogVisible = false">{{ $str.getKey('策略控制/取消') }}</el-button>
        <el-button type="primary" @click="onPastedConfirm">{{ $str.getKey('策略控制/确定') }}</el-button>
      </template>
    </el-dialog>

  </div>

</template>

<script setup>
import { computed, ref, watch, inject, getCurrentInstance, onMounted, onUnmounted, nextTick, provide } from "vue"
import useUserStore from '@/store/modules/user'
import { CloseBold, Plus, Sort } from "@element-plus/icons-vue"
import VChart from 'vue-echarts'
import * as strategyApi from '../api.js'
import {
  cur_elk,
  createOption,
  strategyData2CamelCase,
  checkStrategyValidate, checkStrategyListValidate, isTimeSlotValid, transformJSON,
  timeToMinutes,
  minutesOfDay,
  getChartOption,
  cloneDeep,
  STRATEGY_MODE_OPTIONS,
  getThresholdPlaceholder,
  checkPermi
} from "../utils.js"
import TextEditor from "../components/TextEditor/index.vue"
import AuthVerifyDialog from "../components/AuthVerifyDialog.vue"
import AddPreIcon from '@/assets/images/strategy/btn_pre_add.svg'
import DeletePreIcon from '@/assets/images/strategy/btn_pre_delete.svg'
import SwitchPreIcon from '@/assets/images/strategy/btn_pre_switch.svg'
// 验证码本地缓存（含 5 分钟过期）统一收敛到 smsCodeStore。
// 注意：本文件原有的 saveSmsCode 不写时间戳，若保留会使从本页获取的验证码永不过期。
import { saveSmsCode, clearSmsCode, getSavedSmsCode } from '../smsCodeStore'


const $str = window.$str;

// 检查验证码是否有效的函数
async function isVerificationValid() {
  // 手机号未就绪时无法判断验证码归属，也不该拿空手机号去校验（后端必然失败）
  if (!phoneNumber.value) {
    return false
  }
  // 已过期、或验证码不属于当前手机号时直接判定无效，不必发请求
  const code = getSavedSmsCode(phoneNumber.value)
  if (!code) {
    return false
  }
  try {
    const res = await strategyApi.checkSmsCodeSilent({
      phoneNumber: phoneNumber.value,
      smsCode: code
    })
    return res.code === 200
  } catch (error) {
    console.error('验证码检查失败', error)
    return false
  }
}


const props = defineProps({
  isEdit: { type: Boolean, default: false },
  currentELinkData: { type: Object, default: () => ({}) },
  hideEditButton: { type: Boolean, default: false },
  isElinkGroup: { type: Boolean, default: false },
  hasPvAccess: { type: Boolean, default: false },
})
const emit = defineEmits(['update:isEdit'])

const { proxy } = getCurrentInstance()

/** el-table：合并单元格 >>> [开始时间]&[结束时间] */
function mergeCellMethod({ row, column, rowIndex, columnIndex }) {
  if (columnIndex === 0) {
    return [1, 2]
  } else if (columnIndex === 1) {
    return [0, 0]
  }
}

const isEdit = computed({
  get() {
    return props.isEdit
  },
  set(value) {
    emit('update:isEdit', value)
  }
})
const radio = ref('1')

const option = ref(getChartOption())

const workStrategy = ref([])
const restStrategy = ref([])

// 防逆流相关变量
const hasAntiRefluxPermission = ref(false)
const phoneNumber = ref('') // 添加手机号变量
const workDemandMin = ref(0)
const restDemandMin = ref(0)
const authDialogVisible = ref(false)
// 初始化验证码，如果有有效的保存验证码则使用它
const verificationCode = ref('')
// 待提交的防逆流值缓存
const pendingAntiRefluxValue = ref(null)

const pasteDialogVisible = ref(false)
const pastedValue = ref('')

const tableRef = ref(null)
const mainContainerRef = ref(null) // 内容区滚动容器
const isChangeInput = ref(false)

const checkValueIsInvalid = (value, data) => {
  const limit = parseInt(data?.powerLimit);
  if (isNaN(limit)) { return false; }
  if (value > limit || value < -limit) { return true; }
  return false;
}

// 初始化时检查防逆流权限
onMounted(async () => {
  document.addEventListener('mousemove', handlerMouseMove)
  document.addEventListener('mouseup', handlerMouseUp)

  // 加载时检查权限
  if (props.currentELinkData?.station_id) {
    await checkAntiRefluxPermission()
  }

  // 检查是否有保存的验证码（须归属于当前手机号）
  const code = getSavedSmsCode(phoneNumber.value)
  if (code) {
    // 如果有保存的验证码，检查是否有效
    const isValid = await isVerificationValid()
    if (isValid) {
      verificationCode.value = code
    }
  }

})

// 监听station_id变化，重新检查权限
watch(() => props.currentELinkData?.station_id, async (newVal) => {
  if (newVal) {
    await checkAntiRefluxPermission()
  }
})


/**
 * 表格编辑的策略数据
 * @type {WritableComputedRef<*>}
 */
const tableData = computed({
  get() {
    const obj = {
      1: workStrategy.value,
      2: restStrategy.value,
    }
    return obj[radio.value]
  },
  set(value) {
    const obj = {
      1: (value) => workStrategy.value = value,
      2: (value) => restStrategy.value = value,
    }
    obj[radio.value](value)
  }
})

// 防逆流数字展示
const antiRefluxEnabled = computed({
  get() {
    const obj = {
      1: Number(workDemandMin.value) > -6000 ? true : false,
      2: Number(restDemandMin.value) > -6000 ? true : false,
    }
    return obj[radio.value]
  },
  set(value) {
    console.log(value)
  }
})

let originAntiRefluxValue = undefined;
const antiRefluxValue = computed({
  get() {
    const obj = {
      1: Number(workDemandMin.value),
      2: Number(restDemandMin.value),
    }
    return obj[radio.value]
  },
  set(value) {
    if (radio.value === '1') {
    workDemandMin.value = Number(value)
    syncPeakShavingThreshold(workStrategy.value)
  } else {
    restDemandMin.value = Number(value)
    syncPeakShavingThreshold(restStrategy.value)
  }
  }
})



const isChangeSwitch = ref(false)
// 防逆流开关切换处理
async function onAntiRefluxChange() {
  isChangeSwitch.value = true
  // 获取权限是否有防逆流
  if (hasAntiRefluxPermission.value) {
    originAntiRefluxValue = antiRefluxValue.value; // 暂存，用于取消时恢复
    // 检查验证码是否有效
    const isValid = await isVerificationValid()
    if (isValid) {
      // 验证码有效，直接执行操作
      authDialogVisible.value = false
      if (radio.value === '1') {
        if (Number(workDemandMin.value) > -6000) {
          antiRefluxEnabled.value = true;
          workDemandMin.value = (Number(workDemandMin.value) - 65535)
        } else {
          antiRefluxEnabled.value = false;
          workDemandMin.value = (Number(workDemandMin.value) + 65535)
        }
      } else {
        if (Number(restDemandMin.value) > -6000) {
          antiRefluxEnabled.value = true;
          restDemandMin.value = (Number(restDemandMin.value) - 65535)
        } else {
          antiRefluxEnabled.value = false;
          restDemandMin.value = (Number(restDemandMin.value) + 65535)
        }
      }
    } else {
      // 验证码无效，显示验证对话框
      authDialogVisible.value = true
    }
  }
}

// 检查防逆流权限
async function checkAntiRefluxPermission() {
  try {
    const res = await strategyApi.getStationStrategyConfig(props.currentELinkData.station_id)
    if (res.code == 200) {
      // 解析返回的权限数据
      hasAntiRefluxPermission.value = Boolean(res.data?.preventCounterCurrent) && props.isElinkGroup
      phoneNumber.value = res.data?.phoneNumber // 保存手机号
    }
  } catch (error) {
    console.error('检查防逆流权限失败:', error)
  }
}

async function onAntiRefluxValueChange(value) {
  isChangeInput.value = true
  if (hasAntiRefluxPermission.value) {
    // 检查验证码是否有效
    const isValid = await isVerificationValid()
    if (isValid) {
      // 验证码有效，直接执行操作
      // authDialogVisible.value = false
      if (radio.value === '1') {
        workDemandMin.value = value
      } else {
        restDemandMin.value = value
      }
    } else {
      // 验证码无效，暂存新值并显示验证对话框
      pendingAntiRefluxValue.value = value
      authDialogVisible.value = true
    }
  }
}

function onAuthCancel() {
  if (!isNaN(originAntiRefluxValue)) {
    antiRefluxValue.value = originAntiRefluxValue; // 权限验证取消，恢复原始值
  }

  authDialogVisible.value = false
  isChangeSwitch.value = false
  isChangeInput.value = false
  // 清理待提交值缓存
  pendingAntiRefluxValue.value = null
}

function onAuthConfirm(code) {
  const targetDemandRef = radio.value === '1' ? workDemandMin : restDemandMin
  const currentValue = Number(targetDemandRef.value)

  if (isChangeSwitch.value) {
    targetDemandRef.value = currentValue > -6000 ? (currentValue - 65535) : (currentValue + 65535)
  } else if (isChangeInput.value) {
    // 使用缓存的新值而不是旧值
    const newValue = pendingAntiRefluxValue.value ?? targetDemandRef.value
    targetDemandRef.value = Number(newValue)
    pendingAntiRefluxValue.value = null // 清理缓存
  }
  verificationCode.value = code
  // 同时保存到localStorage中，记录所属手机号与写入时间
  saveSmsCode(phoneNumber.value, code)
  authDialogVisible.value = false
  isChangeSwitch.value = false
  isChangeInput.value = false
}



const DEFAULT_THRESHOLD = 10

/**
 * 门限值记忆表：row -> Map<running_mode, threshold_val>
 * 后端每条策略只存一个 threshold_val 字段，不区分运行模式，
 * 因此在本次编辑会话内记住每个模式最近一次使用的门限值，
 * 切换模式时优先恢复，避免用户填过的值被重置成默认值。
 * 用 WeakMap 是因为 key 是策略行对象，行被删除后记忆自动回收。
 */
const thresholdMemory = new WeakMap()
/** row -> 上一次的 running_mode，用于在切换时把旧模式的值存进记忆表 */
const lastModeMemory = new WeakMap()

function getThresholdMemory(row) {
  let memory = thresholdMemory.get(row)
  if (!memory) {
    memory = new Map()
    thresholdMemory.set(row, memory)
  }
  return memory
}

/** 记住某行在某个模式下的门限值（模式0跟随防逆流值，无需记忆） */
function rememberThreshold(row, mode, value) {
  const modeKey = Number(mode)
  if (!Number.isFinite(modeKey) || modeKey === 0) return
  if (value === '' || value == null || !Number.isFinite(Number(value))) return
  getThresholdMemory(row).set(modeKey, Number(value))
}

function getStrategyThresholdValue(strategy = {}) {
  const threshold = strategy.threshold_val ?? strategy.threshold
  return threshold === '' || threshold == null ? DEFAULT_THRESHOLD : threshold
}

function normalizeStrategyMode(strategy) {
  if (!props.hasPvAccess) {
    return strategy
  }
  strategy.running_mode = Number(strategy.running_mode ?? strategy.mode ?? 0)
  strategy.threshold_val = strategy.running_mode === 0 ? antiRefluxValue.value : getStrategyThresholdValue(strategy)
  // 把后端下发的“当前模式 + 门限值”作为记忆初始值，
  // 这样切到别的模式再切回来时能恢复成保存过的值，而不是默认值
  rememberThreshold(strategy, strategy.running_mode, strategy.threshold_val)
  lastModeMemory.set(strategy, strategy.running_mode)
  return strategy
}

function normalizeStrategyModeList(list = []) {
  list.forEach(normalizeStrategyMode)
}

function syncPeakShavingThreshold(list = []) {
  if (!props.hasPvAccess) {
    return
  }
  list.forEach(strategy => {
    if (Number(strategy.running_mode ?? strategy.mode ?? 0) === 0) {
      strategy.running_mode = 0
      strategy.threshold_val = antiRefluxValue.value
    }
  })
}

/**
 * 更新编辑器显示策略
 */
function updateLocalStrategy() {
  const value = props.currentELinkData
  if (value) {
    workDemandMin.value = cloneDeep(value.demand_min_weekday) || 0
    restDemandMin.value = cloneDeep(value.demand_min_weekend) || 0
    workStrategy.value = cloneDeep(value.strategys_work || [])
    restStrategy.value = cloneDeep(value.strategys_rest || [])
    normalizeStrategyModeList(workStrategy.value)
    normalizeStrategyModeList(restStrategy.value)
  }
}

/**
 * 提供给外部的方法:用于获取编辑完成的策略
 * @param isEffective 是否获取有效的策略
 * @param transform2Camel 是否转化为驼峰
 * @returns {{rest: *[], work: *[], workDemandMin: number, restDemandMin: number}}
 */
function getStrategys(isEffective = true, transform2Camel) {
  return {
    work: isEffective ? getEffectiveStrategy(workStrategy.value, transform2Camel) : workStrategy.value,
    rest: isEffective ? getEffectiveStrategy(restStrategy.value, transform2Camel) : restStrategy.value,
    workDemandMin: workDemandMin.value,
    restDemandMin: restDemandMin.value,

  }
}

/**
 * 获取有效的策略
 * @param value 策略数组
 * @param transform2Camel 是否转化为驼峰
 * @returns {*[]}
 */
function getEffectiveStrategy(value = [], transform2Camel = false) {
  const result = []
  for (const strategy of value) {
    let camelStrategy = strategyData2CamelCase(strategy)
    let valid = checkStrategyValidate(camelStrategy, props.currentELinkData.powerLimit)
    if (valid) {
      result.push(transform2Camel ? camelStrategy : strategy)
    }
  }
  return result
}

/**
 * 监听策略数据，更新图表
 */
watch(tableData, () => {
  const strategyList = getEffectiveStrategy(tableData.value)
  option.value = createOption(strategyList, props.currentELinkData.powerLimit)
}, {
  deep: true,
  immediate: true,
})

/**
 * 创建一条策略
 * @returns {{start_time: string, lower_limit: string, end_time: string, upper_limit: string, power: string}}
 */
function createOneStrategy() {
  return {
    start_time: '',
    end_time: '',
    power: '0',
    upper_limit: '100.0',
    lower_limit: '0.0',
    running_mode: 0,
    threshold_val: 10,
  }
}

/**
 * 在当前行下添加一行
 * @param row
 */
function addLine(row) {
  let index = tableData.value.indexOf(row)
  tableData.value.splice(index + 1, 0, createOneStrategy())
}


/**
 * 在末尾添加一行
 */
function addToEnd() {
  tableData.value.push(createOneStrategy())
}


/**
 * 删除一行
 * @param row
 */
function removeLine(row) {
  tableData.value = tableData.value.filter(item => item !== row)
}


function startEdit() {
  isEdit.value = true
}

function exitEdit() {
  isEdit.value = false
  updateLocalStrategy()
}

function copyStrategy() {
  const text = JSON.stringify(transformJSON(tableData.value, false), null, 2)
  copyText(text)
  // sessionStorage.setItem('eMind.clipboard.strategy', text)
  window.dispatchNotify({
    type: 'success',
    message: $str.getKey('策略控制/复制成功!')
  });
}

function pasteStrategy() {
  pasteDialogVisible.value = true
  pastedValue.value = ''
}

function onPastedConfirm() {
  const s = pastedValue.value
  const is_str_arr = (str) => {
    return str.startsWith('[') && str.endsWith(']')
  }
  if (s) {
    if (is_str_arr(s)) {
      try {
        const strategy = JSON.parse(s)

        let isValid = checkStrategyListValidate(strategy, props.currentELinkData.powerLimit)
        if (!isValid) {
          nextTick(() => {
            window.dispatchNotify({
              type: 'info',
              message: $str.getKey("策略控制/策略格式不正确!")
            });
          })
          return
        }

        if (tableData.value.length > 0) {
          proxy.$confirm(
            $str.getKey("策略控制/已经存在策略，确定要替换吗？"),
            $str.getKey("全局/提示"),
            {
              confirmButtonText: $str.getKey("策略控制/确定"),
              cancelButtonText: $str.getKey("策略控制/取消"),
              type: "warning",
            }
          )
            .then(() => {
              normalizeStrategyModeList(strategy)
              tableData.value = strategy
            })
            .catch((e) => {
              console.warn(e);
            });
        } else {
          normalizeStrategyModeList(strategy)
          tableData.value = strategy
        }
      } catch (error) {
        console.warn(error);
        window.dispatchNotify({
          type: 'info',
          message: $str.getKey("策略控制/粘贴失败!")
        });
      }
      pasteDialogVisible.value = false
    } else {
      nextTick(() => {
        window.dispatchNotify({
          type: 'info',
          message: $str.getKey("策略控制/策略格式或数据不正确!")
        });
      })
    }
  } else {
    pasteDialogVisible.value = false
  }
}


function copyText(text) {
  var textarea = document.createElement('textarea');
  textarea.setAttribute('readonly', 'readonly'); //设置只读属性防止手机上弹出软键盘
  textarea.value = text;
  document.body.appendChild(textarea); //将textarea添加为body子元素
  textarea.select();
  var res = document.execCommand('copy');
  document.body.removeChild(textarea);//移除DOM元素
  return res;
}



function coverTest(strategyList) {
  let sumMinutes = 0
  for (const strategy of strategyList) {
    let startMinutes = timeToMinutes(strategy.start_time)
    let endMinutes = timeToMinutes(strategy.end_time)
    let dist = endMinutes - startMinutes
    sumMinutes += dist
  }
  return minutesOfDay - 1 === sumMinutes || minutesOfDay === sumMinutes
}



/**
 * 检测输出策略有效性
 * @returns {boolean}
 */
function checkValidate() {
  const hasPowerNoData = tableData.value.some(it => it.power === '');
  if (hasPowerNoData) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/功率值不能为空，请检查！')
    });
    return false
  }
  const upLimit = tableData.value.some(it => it.upper_limit === '');
  if (upLimit) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/充电上限不能为空，请检查！')
    });
    return false
  }
  const lowerLimit = tableData.value.some(it => it.lower_limit === '');
  if (lowerLimit) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/放电下限不能为空，请检查！')
    });
    return false
  }
  const hasFloatNumPower = tableData.value.some(it => !isInteger(it.power));
  if (hasFloatNumPower) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/功率值不能为小数，请检查！')
    });
    return false
  }

  const strategys = getStrategys(false)
  const powerLimit = props.currentELinkData.powerLimit
  let valid = checkStrategyListValidate(strategys.rest, powerLimit) && checkStrategyListValidate(strategys.work, powerLimit)
  if (!valid) {
    return false
  }

  // 判断是否有策略未设置
  if (strategys.work.length < 1) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/请设置工作日策略!')
    });
    return false
  } else if (strategys.rest.length < 1) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/请设置休息日策略!')
    });
    return false
  }

  const text = $str.getKey('策略控制/策略时间槽不正确，请设置连续的时段，且范围覆盖 00:00-23:59');

  if (!isTimeSlotValid(strategys.work) || !coverTest(strategys.work)) {
    window.dispatchNotify({
      type: 'info',
      message: `${$str.getKey('策略控制/工作日')}${text}`
    });
    return false
  }

  if (!isTimeSlotValid(strategys.rest) || !coverTest(strategys.rest)) {
    window.dispatchNotify({
      type: 'info',
      message: `${$str.getKey('策略控制/休息日')}${text}`
    });
    return false
  }

  return true
}



let mousedown = false
let currentRow = null
function onSortBtnDown(row) {
  mousedown = true
  currentRow = row
}

function handlerMouseUp() {
  mousedown = false
  visible.value = false
  currentRow = null
}


function getLocationPosition(target, pageX, pageY) {
  const { left, top, height } = target.getBoundingClientRect()
  return {
    x: pageX - left,
    y: pageY - top,
    height: height,
  }
}


const barTop = ref(0)
const visible = ref(false)

function handlerMouseMove(event) {
  if (!mousedown) {
    return
  }

  // log('move')
  visible.value = true

  if (tableData.value.length === 0) {
    return
  }
  const target = document.querySelector('.el-table__body-wrapper')
  const scrollWrap = target.querySelector('.el-scrollbar__wrap')
  const row = document.querySelector('.el-table__row')
  const { x, y, height: targetHeight } = getLocationPosition(target, event.pageX, event.pageY)
  const { height: rowHeight } = row.getBoundingClientRect()

  const targetIndex = Math.floor((y + scrollWrap.scrollTop + rowHeight / 2) / rowHeight)

  if (targetIndex <= -1 || targetIndex > tableData.value.length) {
    return
  }


  let hd = document.querySelector('.el-table__header-wrapper')
  let { height } = hd.getBoundingClientRect()
  const srcIndex = tableData.value.indexOf(currentRow)

  if (y > targetHeight) {
    tableRef.value.setScrollTop(rowHeight * targetIndex)
  }
  else if (y < 0) {
    tableRef.value.setScrollTop(0)
  }

  // 向下移动
  if (srcIndex < targetIndex) {
    if (targetIndex - srcIndex > 1) {
      let moved = tableData.value.splice(srcIndex, 1)
      tableData.value.splice(targetIndex - 1, 0, currentRow)
    }
  }
  // 向上移动
  else if (srcIndex > targetIndex) {
    let moved = tableData.value.splice(srcIndex, 1)
    tableData.value.splice(targetIndex, 0, currentRow)
  }

  // barTop.value = targetIndex * rowHeight + height - scrollWrap.scrollTop
  barTop.value = (targetIndex + 1) * rowHeight + height - scrollWrap.scrollTop + 10

}

/** 编辑功率值时，判断输入不能为空 */
function inputPowerChange(e) {
  if (e.target.value === '') {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/功率不能为空，请输入！')
    });
  }
}

/** 判断传入值是否为整数 */
function isInteger(value) {
  const num = parseFloat(value);
  if (num > 0) {
    return num === Math.floor(value);
  } else {
    return num === Math.round(value);
  }
}


onMounted(() => {
  document.addEventListener('mousemove', handlerMouseMove)
  document.addEventListener('mouseup', handlerMouseUp)
})


onUnmounted(() => {
  document.removeEventListener('mousemove', handlerMouseMove)
  document.removeEventListener('mouseup', handlerMouseUp)
})


defineExpose({
  updateLocalStrategy,
  getStrategys,
  checkValidate,
  startEdit,
  exitEdit,
  /** 滚动条回到顶部（抽屉每次打开时调用，避免沿用上次的滚动位置） */
  scrollToTop: () => {
    if (mainContainerRef.value) {
      mainContainerRef.value.scrollTop = 0
    }
  },
  getVerificationCode: async () => {
    // 如果当前组件中有验证码，直接返回
    if (verificationCode.value) {
      // 检查验证码是否有效
      const isValid = await isVerificationValid()
      if (isValid) {
        return verificationCode.value
      }
    }

    // 从localStorage中获取验证码（须归属于当前手机号）
    const savedCode = getSavedSmsCode(phoneNumber.value)
    if (savedCode) {
      // 检查验证码是否有效
      const isValid = await isVerificationValid()
      if (isValid) {
        // 如果有效，更新组件内部的验证码变量并返回
        verificationCode.value = savedCode
        return savedCode
      } else {
        // 验证码无效，清除
        clearSmsCode()
      }
    }
  }
})

function onUpperLimitChange(row) {
  if (Number(row.upper_limit) < Number(row.lower_limit)) {
    row.upper_limit = row.lower_limit;
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/放电下限不能高于充电上限，已自动修正')
    });
  }
  if (row.upper_limit === '') {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/充电上限不能为空，请输入！')
    });
  }
}
function onLowerLimitChange(row) {
  if (Number(row.lower_limit) > Number(row.upper_limit)) {
    row.lower_limit = row.upper_limit;
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/充电上限不能低于放电下限，已自动修正')
    });
  }
  if (row.lower_limit === '') {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/放电下限不能为空，请输入！')
    });
  }
}

function onModeChange(row) {
  // 先把切换前那个模式下的门限值存进记忆表，便于之后切回来时恢复
  const prevMode = lastModeMemory.get(row)
  if (prevMode != null) {
    rememberThreshold(row, prevMode, row.threshold_val)
  }

  const mode = Number(row.running_mode)
  lastModeMemory.set(row, mode)

  // 削峰填谷的门限值固定跟随防逆流值，不使用记忆值
  if (mode === 0) {
    row.threshold_val = antiRefluxValue.value
    return
  }

  // 其余模式：优先恢复本行该模式用过的值，没有记录过才用默认值
  const remembered = getThresholdMemory(row).get(mode)
  row.threshold_val = remembered ?? DEFAULT_THRESHOLD
}

function onThresholdChange(row) {
  const value = Math.round(Number(row.threshold_val))
  if (!Number.isFinite(value)) {
    row.threshold_val = 0
    rememberThreshold(row, row.running_mode, row.threshold_val)
    return
  }
  row.threshold_val = Math.min(1000, Math.max(0, value))
  rememberThreshold(row, row.running_mode, row.threshold_val)
}

</script>

<style scoped lang="scss">
.page-container {
  $top-container-height: 50px;
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px;

  .top-container {
    height: $top-container-height;
    // background: aqua;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .operate-btns-container {
      .el-button.is-plain {
        // background: #21263B;
        // box-shadow: inset 0px 0px 8px 0px currentColor;
        border: 1px solid currentColor;

        &.edit {
          color: #3A68FF;
          border-color: #3A68FFAA;

          &:hover {
            background: #3A68FF33;
          }
        }

        &.copy {
          color: #FF1942;
          border-color: #FF1942AA;

          &:hover {
            background: #FF194233;
          }
        }

        &.paste {
          color: #444A6D;
          border-color: #444A6DAA;

          &:hover {
            background: #444A6D33;
          }
        }

        &.clear {
          color: #444A6D;
          border-color: #444A6DAA;

          &:hover {
            background: #444A6D33;
          }
        }
      }
    }

  }

  .main-container {
    flex: 1 1 calc(100% - $top-container-height);
    // 子项高度按内容展开，整体超出时在这里出滚动条
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    // background: aqua;
    position: relative;
    display: flex;
    flex-direction: column;

    // 防逆流开关样式
    .anti-reflux-container {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      flex: none;
      margin-bottom: 16px;
      padding: 12px 16px;
      background: #FFFFFF;
      border-radius: 6px;
      margin-top: 10px;

      .anti-reflux-label {
        color: #2E2E2E;
        margin-right: 12px;
        font-size: 14px;
        font-weight: 500;
        white-space: nowrap;
      }

      .el-switch {
        margin-right: 16px;
        min-width: 40px;
      }

      .anti-reflux-value {
        color: #42FDA3;
        font-size: 14px;
        margin-left: 8px;
        margin-right: 12px;
        padding: 4px 10px;
        background: rgba(66, 253, 163, 0.1);
        border-radius: 4px;
        white-space: nowrap;
      }

      .edit-hint {
        color: #8EA1CC;
        font-size: 13px;
        font-style: italic;
        margin-left: auto; // 推到右侧
        white-space: nowrap;
      }

      @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;

        .anti-reflux-label {
          margin-bottom: 0;
        }

        .el-switch {
          margin-bottom: 0;
        }

        .anti-reflux-value {
          margin-left: 0;
          margin-bottom: 0;
        }

        .edit-hint {
          margin-left: 10px !important;
          margin-top: 4px;
        }
      }
    }

    // --设置自定义表格样式----------------
    ::v-deep .el-table {

      // 取消边框
      .el-table__cell {
        // border-style: none;
      }

      // 设置表头样式
      .el-table__header {
        .el-table__cell {
          height: 50px;

          .cell {
            color: #96A5B8;
            display: flex;
            justify-content: center;
            font-size: 12px !important;
          }
        }
      }

      // 设置行的hover样式
      .el-table__body {
        .el-table__row:hover {
          // background-color: #39456606 !important;
          background-color: #ffffff !important;

          td.el-table__cell {
            background-color: #39456606 !important;
            // background-color: #ffffff !important;
          }
        }
      }

      // CELL里的内容的样式
      .table-cell {
        .cell {
          padding: 0 8px;
        }

        .cell-content {
          // background: #FFFFFF;
          background: transparent;
          // border-radius: 6px 6px 6px 6px;
          width: 100%;
          height: 50px;

          display: flex;
          justify-content: space-around;
          align-items: center;

          .separator {
            width: 40px;
            border: 1px solid #8EA1CC;
            position: absolute;
            margin: auto;
          }

          .s-underline-input {
            background: transparent;
            text-align: center;
            border-width: 0 0 2px 0;
            border-color: transparent;
            outline: none;

            &.input-error-value {
              color: red;
              border-bottom: 1px solid red;
            }
          }
        }

        // 模式列：下拉框 + 门限值输入框
        .mode-cell {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
          padding: 0 6px;
          flex-wrap: nowrap;

          .mode-select {
            flex: 0 0 130px;
            width: 130px;

            :deep(.el-input__wrapper) {
              padding: 0 8px;
            }
            :deep(.el-select__placeholder),
            :deep(.el-input__inner) {
              font-size: 12px;
            }
          }

          .threshold-input {
            flex: 1 1 auto;
            width: 100%;
            min-width: 0;
            text-align: left;
            padding: 0 4px;
            border-bottom: 1px solid #DCDFE6 !important;
            text-overflow: ellipsis;

            &::placeholder {
              color: #C0C4CC;
              font-size: 12px;
            }

            &:disabled {
              color: #C0C4CC;
              cursor: not-allowed;
            }
          }
        }

        .operate-cell-container {
          display: flex;
          justify-content: space-around;
          align-items: center;

          .el-button.is-plain {
            // background: #21263B;
            // box-shadow: inset 0px 0px 8px 0px currentColor;
            // border: 1px solid currentColor;
            border-width: 0;
            background: none;
            .btn-wrapper {
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 4px;
            }

            &.add {
              color: #36B60C;
              border-color: #36B60CAA;

              &:hover {
                // background: #36B60C33;
                filter: brightness(1.2);
              }
            }

            &.delete {
              color: #FF1E1E;
              border-color: #FF1E1EAA;

              &:hover {
                // background: #FF1E1E33;
                filter: brightness(1.2);
              }
            }

            &.move {
              color: #3A68FF;
              border-color: #3A68FFAA;

              &:hover {
                // background: #3A68FF33;
                filter: brightness(1.2);
              }

              &.cursor-move {
                cursor: move;
              }
            }
          }
        }
      }
    }

    .move-bar {
      z-index: 2;
      width: 100%;
      background: #3A68FF;
      position: absolute;
      top: 0;
      height: 2px;

      display: flex;
      align-items: center;

      &::before {
        content: '';
        width: 10px;
        height: 10px;
        border: 3px solid rgb(6 182 212 / var(--tw-bg-opacity));
        border-radius: 50%;
        position: relative;
        left: -7px;
      }
    }
    

    /* 时段策略表格：不设固定高度也不内部滚动，按行数完整展开，
       内容超出时由 .main-container 整体滚动 */
    .table-wrap {
      flex: none;
      width: 100%;
    }

    .el-button.add-btn {
      width: 100%;
      height: 50px;
      color: #000000;
      flex: none;
    }

    /* 图表固定高度且不参与压缩，保证甘特图始终完整显示 */
    .chart-container {
      height: 200px !important;
      flex: none;
    }




  }
}

// 调整input-type:time的时钟图标的颜色
::-webkit-calendar-picker-indicator {
  filter: invert(60%);
}
</style>
